import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HeaderComponent } from "./header.component";
import { AppRoutingModule } from "src/app/app-routing.module";
import { TranslateModule } from "@ngx-translate/core";
import { TranslationModule } from "src/app/pipes/translation/translation.module";
import { MapLangToIsoModule } from "src/app/pipes/map-lang-to-iso/map-lang-to-iso.module";

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, AppRoutingModule, TranslateModule, TranslationModule, MapLangToIsoModule],
  exports: [HeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeaderModule { }
